import React, { FC } from 'react';
import { AvailableFeaturesUpselling, FeatureUpselling as FeatureUpsellingModule } from '@dev/ee-modules';
import { goBack } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ProductCode } from '@dev/ee-api/ee-api-models';

import { useMobile } from '@/services/hooks/useMobile';
import { BillingPaths, pathsParams } from '@/services/dictionaries/Paths';

interface FeatureUpsellingI {
    feature: AvailableFeaturesUpselling;
}

export const FeatureUpselling: FC<FeatureUpsellingI> = ({ feature }: FeatureUpsellingI): JSX.Element => {
    const isMobile = useMobile();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const availableBreadcrumbs = {
        [AvailableFeaturesUpselling.CustomFields]: {
            text: t('segments'),
            onClick: () => dispatch(goBack()),
        },
        [AvailableFeaturesUpselling.Webhooks]: {
            text: t('settings'),
            onClick: () => dispatch(goBack()),
        },
        [AvailableFeaturesUpselling.InboundEmails]: {
            text: t('settings'),
            onClick: () => dispatch(goBack()),
        },
    };

    return (
        <FeatureUpsellingModule
            feature={feature}
            isMobile={isMobile}
            breadcrumbs={availableBreadcrumbs?.[feature]}
            billingPathname={BillingPaths.BillingPlanList.replace(
                pathsParams.productCode,
                ProductCode.Marketing.toLowerCase()
            )}
        />
    );
};
